import {ColorSchemeDataModel} from '../../../../models/configuration/color-scheme-data.model';

export class TdoColorSchemePickerEvent {
  value: ColorSchemeDataModel;

  constructor(value: ColorSchemeDataModel) {
    this.value = value;
  }
}
